import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const features = [
  'Unlimited cancellation handling via email',
  'Custom retention playbook built for your brand',
  'Integration with your existing helpdesk',
  'Monthly reporting on saves and churn drivers',
  'Dedicated retention specialist',
  '30 day money back guarantee',
];

export default function Pricing() {
  return (
    <section data-testid="pricing-section" className="py-28 px-6 lg:px-10 bg-[#FAFAF7]">
      <div className="max-w-lg mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0A1628]/40 mb-4">
            Pricing
          </p>
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-[#0A1628]">
            One straightforward plan
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          data-testid="pricing-card"
          className="bg-white rounded-2xl p-10 border-2 border-[#00D4B8] shadow-[0_24px_80px_rgba(0,212,184,0.12)]"
        >
          {/* Tag */}
          <div className="inline-flex items-center gap-2 bg-[#00D4B8]/10 text-[#0A1628] text-xs font-bold uppercase tracking-[0.15em] px-4 py-2 rounded-full mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-[#00D4B8]" />
            Pilot Program — Limited Spots
          </div>

          {/* Price */}
          <div className="flex items-baseline gap-2 mb-8">
            <span
              data-testid="pricing-price"
              className="text-6xl font-black tracking-tighter text-[#0A1628]"
            >
              $2,500
            </span>
            <span className="text-base font-medium text-[#1A1A1A]/45">/month AUD</span>
          </div>

          {/* Features */}
          <div className="space-y-4 mb-10">
            {features.map((f) => (
              <div key={f} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-[#00D4B8]/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check size={12} strokeWidth={2.5} className="text-[#00D4B8]" />
                </div>
                <span className="text-sm text-[#1A1A1A]/70 leading-relaxed">{f}</span>
              </div>
            ))}
          </div>

          {/* CTA */}
          <a
            href="#book"
            data-testid="pricing-cta"
            className="block w-full text-center bg-[#0A1628] text-[#FAFAF7] font-semibold text-base py-4 rounded-2xl hover:scale-[1.02] hover:bg-[#0A1628]/90 transition-all duration-200 shadow-md"
          >
            Book a discovery call
          </a>
        </motion.div>
      </div>
    </section>
  );
}
